import gql from 'graphql-tag';

export default gql`
  query applicationKidsCafe($applicationKidsCafeId: ID!) {
    applicationKidsCafe(applicationKidsCafeId: $applicationKidsCafeId) {
      applicationKidsCafeId
      applicationYear
      status
      type
      new
      forProfit
      participatedAgriculture
      agricultureSponsor
      childcareLicense
      hasWifi
      hasRecordingDevice
      hasStorage
      receivesDeliveries
      isChildcareCenter
      hasMicrowave
      isTexasRisingStar
      isFederalParticipant
      isOpenEnrolledYear
      hasInfantsEnrolled
      hasAfterSchool
      specialDeliveryNotes
      earliestDeliveryTime
      fieldTrips
      startDate
      endDate
      operatingHoursStartTime
      operatingHoursEndTime
      gateCode
      numExpectedParticipants
      numExpectedParticipantsBreakfast
      numExpectedParticipantsBrunch
      numExpectedParticipantsLunch
      numExpectedParticipantsBogoLunch
      numExpectedParticipantsSnack
      numExpectedParticipantsSupper
      participantAgeRanges
      daysForService
      interestBreakfast
      interestBrunch
      interestLunch
      interestBogoLunch
      interestSnack
      interestSupper
      breakfastStartTime
      breakfastEndTime
      brunchStartTime
      brunchEndTime
      lunchStartTime
      lunchEndTime
      bogoLunchStartTime
      bogoLunchEndTime
      snackStartTime
      snackEndTime
      supperStartTime
      supperEndTime
      enrichmentPrograms
      closureDates
      referredBy
      agreeToReimbursement
      agreeToDocumentation
      certififedVerification
      nameSign
      siteType
      agreeToProgramPurpose
      enrichmentDoc1Url
      enrichmentDoc2Url
      enrichmentDoc3Url
      submittedAt
      site {
        siteId
        name
        address1
        address2
        city
        county
        state
        zip
        closestSchool
        crossStreet
        primaryPointOfContact {
          siteMemberId
          firstName
          lastName
          title
          phone
          email
          type
          isSupervisor
        }
        secondaryPointOfContact {
          siteMemberId
          firstName
          lastName
          title
          phone
          email
          type
          isSupervisor
        }
      }
    }
  }
`;
